module.exports = __webpack_public_path__ + "static/img/11.e053dc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/11.png
// module id = AYGq
// module chunks = 0